import Vue from 'vue'
import Router from 'vue-router'
// import Main from '@/components/Pages/Home'
import Login from '@/components/Login'
import store from '../store/index'
// Sites
import Sites from '@/components/Pages/Sites/Sites'
import Site from '@/components/Pages/Site/Site'
import Tags from '@/components/Pages/Sites/Tags'

import AdminUser from '@/components/Pages/Admin/User'
import AdminUsers from '@/components/Pages/Admin/Users'

import AdminUserRole from '@/components/Pages/Admin/Role'
import AdminUserRoles from '@/components/Pages/Admin/Roles'
import AdminBilling from '@/components/Pages/Admin/Billing'

import Data from '@/components/Pages/Admin/Data/Data'
import DataLists from '@/components/Pages/Admin/DataLists/DataLists'

import AccountRegistrar from '@/components/Pages/Accounts/Registrar'
import AccountRegistrars from '@/components/Pages/Accounts/Registrars'

import AccountHost from '@/components/Pages/Accounts/Host'
import AccountHosts from '@/components/Pages/Accounts/Hosts'

import PostSearch from '@/components/Pages/Posts/Search'

import Clients from '@/components/Pages/Client/List'
import Client from '@/components/Pages/Client/Client'

import Stats from '@/components/Pages/Stats/Stats'

import LinkPyramids from '@/components/Pages/Apps/LinkPyramid'
import LinkPyramid from '@/components/Pages/Apps/link-pyramid/Pyramid'

import XsUploads from '@/components/Pages/Xs/Uploads'
import XsUpload from '@/components/Pages/Xs/Upload'

import Manager from '@/components/Pages/Manager/Sites'
import ASite from '@/components/Pages/Manager/Site'
import ATags from '@/components/Pages/Manager/Tags'

import CntryKw from '@/components/Pages/Seo/CountryKeywords'

import BatchUpdate from '@/components/Pages/Manager/BatchUpdate/Plugins'

import StdIndexChecker from '@/components/Pages/Std/IndexChecker'
import StdIndexCheck from '@/components/Pages/Std/IndexChecker/Check'

import ToolboxHaxGrader from '@/components/Pages/Std/SiteGrader'
import ToolboxSiteGrader from '@/components/Pages/Std/HaxSiteGrader'
import ToolboxSiteChecker from '@/components/Pages/Std/SiteChecker'
import ToolboxSiteGraderOrder from '@/components/Pages/Std/SiteGrader/Order'
import GoogleIndexHelper from '@/components/Pages/Std/GoogleIndexHelper'

import ToolboxPbns from '@/components/Pages/Pbn/Pbns'
import ToolboxPbn from '@/components/Pages/Pbn/Pbn'
import ToolboxPbnOverview from '@/components/Pages/Pbn/Overview'

import ToolboxPbnBuilds from '@/components/Pages/Pbn/Builds'

import ToolboxPbnBuildsReport from '@/components/Pages/Pbn/Build/Report'

import ToolboxPbnOrders from '@/components/Pages/Pbn/Orders'
import ToolboxPbnOrder from '@/components/Pages/Pbn/Order'

import ToolboxPbnLinkOrders from '@/components/Pages/Pbn/LinkOrders'
import ToolboxPbnLinkOrder from '@/components/Pages/Pbn/Links/Order'

import ToolboxPbnBuildQueue from '@/components/Pages/Pbn/Build/Queue'

import ToolboxDomains from '@/components/Pages/Pbn/Domains'

import ToolboxLinkTags from '@/components/Pages/Pbn/Links/Tags'
import ToolboxLinkTag from '@/components/Pages/Pbn/Links/Tag'

import ToolboxFootprintManager from '@/components/Pages/Pbn/FootprintManager/Index'

import ToolboxPbnDashboard from '@/components/Pages/Pbn/Dashboard'

import ToolboxMaintenanceOrders from '@/components/Pages/MaintenanceOrder/Orders'
import ToolboxMaintenanceOrderSingle from '@/components/Pages/MaintenanceOrder/Order'

import ToolboxMaintenanceTask from '@/components/Pages/MaintenanceOrder/Task'
import ToolboxMaintenanceTasks from '@/components/Pages/MaintenanceOrder/Tasks'

import ToolboxPbnTemplates from '@/components/Pages/Pbn/Templates/Templates'
import ToolboxPbnTemplate from '@/components/Pages/Pbn/Templates/Template'

import ClientAccountUsers from '@/components/Pages/ClientAccount/Users'
import ClientAccountUser from '@/components/Pages/ClientAccount/User'
import ClientAccountBilling from '@/components/Pages/ClientAccount/Billing'

import ToolBoxIPOverview from '@/components/Pages/IPOverview/IPContent'

import ServiceAccounts from '@/components/Pages/ServiceAccounts/ServiceAccounts'
import ServiceAccount from '@/components/Pages/ServiceAccounts/SingleView/ServiceAccount'

import Invoices from '@/components/Pages/Admin/Billing/Invoices'
import SingleInvoice from '@/components/Pages/Admin/Billing/Tabs/Billing/Invoice'
import NewInvoice from '@/components/Pages/Admin/Billing/Tabs/Billing/CreateInvoice'
import BillingAccounts from '@/components/Pages/Admin/Billing/Accounts'
import BillingContacts from '@/components/Pages/Admin/Billing/Contacts'
import BillingItems from '@/components/Pages/Admin/Billing/Items'
import BillingTracking from '@/components/Pages/Admin/Billing/Tracking'

import Projects from '@/components/Pages/TaskManager/Projects/Projects'
import Project from '@/components/Pages/TaskManager/Projects/Single/Project'

import TaskList from '@/components/Pages/TaskManager/Tasks/Tasks'
import TaskDetail from '@/components/Pages/TaskManager/Tasks/Single/Task'

import AffiliateCompanies from '@/components/Pages/Advertisers/AffiliateCompanies'
import AffiliateCompany from '@/components/Pages/Advertisers/AffiliateCompany'

import Advertisers from '@/components/Pages/Advertisers/Brands'
import Advertiser from '@/components/Pages/Advertisers/Brand'

import Toplists from '@/components/Pages/Advertisers/Toplists'
import Toplist from '@/components/Pages/Advertisers/Toplist'

import InstalinkoWebmasters from '@/components/Pages/Instalinko/Webmasters'
import InstalinkoWebmaster from '@/components/Pages/Instalinko/Webmaster'
import InstalinkoOrders from '@/components/Pages/Instalinko/Orders'
import InstalinkoOrder from '@/components/Pages/Instalinko/Order'
import InstalinkoInventories from '@/components/Pages/Instalinko/Inventories'
import InstalinkoInventoryAdd from '@/components/Pages/Instalinko/InventoryAdd'
import InstalinkoInventory from '@/components/Pages/Instalinko/Inventory'
import InstalinkoWriters from '@/components/Pages/Instalinko/Writers'
import InstalinkoClients from '@/components/Pages/Instalinko/Clients'
import InstalinkoClient from '@/components/Pages/Instalinko/Client'
import InstalinkoReports from '@/components/Pages/Instalinko/Reports'

Vue.use(Router)
Vue.use(store)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active in',
  linkExactActiveClass: 'active in',
  routes: [
    {
      path: '/',
      name: 'Pbns ',
      component: ToolboxPbns,
      meta: {
        breadcrumb: 'Pbns',
        auth: true
      }
    },
    {
      path: '/pbn/dashboard',
      name: 'Pbn Dashboard',
      component: ToolboxPbnDashboard,
      meta: {
        breadcrumb: 'Pbn Dashboard',
        auth: true
      }
    },
    {
      path: '/sites/',
      name: 'Sites',
      component: Sites,
      meta: {
        breadcrumb: 'Sites',
        auth: true,
        menu: 'Sites'
      },
      children: [
        {
          path: '/sites/categories/',
          name: 'Categories',
          component: Sites,
          meta: {
            breadcrumb: 'Categories',
            menu: 'Sites'
          }
        }
      ]
    },
    {
      path: '/sites/tags',
      name: 'Tags',
      component: Tags,
      meta: {
        breadcrumb: 'Tags',
        menu: 'Sites'
      }
    },
    {
      path: '/ip-overview',
      name: 'ToolBoxIPOverview',
      component: ToolBoxIPOverview,
      meta: {
        breadcrumb: 'IP Overview'
      }
    },
    {
      path: '/service-accounts',
      name: 'Service Accounts',
      component: ServiceAccounts,
      meta: {
        breadcrumb: 'Service Accounts',
        menu: 'Service Accounts'
      }
    },
    {
      path: '/service-accounts/:id',
      name: 'Service Account',
      component: ServiceAccount,
      meta: {
        breadcrumb: 'Account Credentials',
        menu: 'Service Accounts'
      }
    },
    {
      path: '/manager',
      name: 'Manager',
      component: Manager,
      meta: {
        breadcrumb: 'Manager',
        menu: 'Sites'
      }
    },
    {
      path: '/manager/site/:url',
      name: 'Adult Site',
      component: ASite,
      meta: {
        breadcrumb: 'Site',
        menu: 'Sites'
      }
    },
    {
      path: '/manager/tags',
      name: 'Adult Tags',
      component: ATags,
      meta: {
        breadcrumb: 'Tags',
        menu: 'Tags'
      }
    },
    {
      path: '/manager/plugin-batch-update',
      name: 'Batch Update',
      component: BatchUpdate,
      meta: {
        breadcrumb: 'Batch update',
        menu: 'Batch update'
      }
    },
    {
      path: '/seo/country-keywords',
      name: 'Country Keywords',
      component: CntryKw,
      meta: {
        breadcrumb: 'Seo',
        menu: 'Keywords'
      }
    },
    {
      path: '/seo/country-keywords/:country',
      name: 'Country Keyword',
      component: CntryKw,
      meta: {
        breadcrumb: 'Seo',
        menu: 'Keywords'
      }
    },
    {
      path: '/std/index-checker',
      name: 'Index Checker',
      component: StdIndexChecker,
      meta: {
        breadcrumb: 'SEO Tools Dir',
        menu: 'Index Checker'
      }
    },
    {
      path: '/std/index-checker/check/:id',
      name: 'Index Check',
      component: StdIndexCheck,
      meta: {
        breadcrumb: 'Index Check',
        menu: 'Index Check'
      }
    },
    {
      path: '/toolbox/site-grader',
      name: 'Site Grader',
      component: ToolboxSiteGrader,
      meta: {
        breadcrumb: 'Site Grader',
        menu: 'Site Grader'
      }
    },
    {
      path: '/toolbox/site-checker',
      name: 'Site Checker',
      component: ToolboxSiteChecker,
      meta: {
        breadcrumb: 'Site Checker',
        menu: 'Site Checker'
      }
    },
    {
      path: '/toolbox/google-index-helper',
      name: 'Google Index Helper',
      component: GoogleIndexHelper,
      meta: {
        breadcrumb: 'Index Helper',
        menu: 'Google Index Helper'
      }
    },
    {
      path: '/toolbox/hax-grader',
      name: 'Hax Site Grader',
      component: ToolboxHaxGrader,
      meta: {
        breadcrumb: 'Hax Site Grader',
        menu: 'Hax Site Grader'
      }
    },
    {
      path: '/toolbox/site-grader/order/:id',
      name: 'Site Grader Order',
      component: ToolboxSiteGraderOrder,
      meta: {
        breadcrumb: 'Site Grader Order',
        menu: 'Site Grader Order'
      }
    },
    {
      path: '/pbn/link-tags/:domain',
      name: 'Link Tag',
      component: ToolboxLinkTag,
      meta: {
        breadcrumb: 'Link Tag',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/link-tags',
      name: 'Link Tags',
      component: ToolboxLinkTags,
      meta: {
        breadcrumb: 'Link Tags',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/footprint-manager',
      name: 'Footprint Manager',
      component: ToolboxFootprintManager,
      meta: {
        breadcrumb: 'Footprint Manager',
        menu: 'Pbns'
      }
    },
    {
      path: '/lists/tech',
      name: 'Tech View',
      component: () => import('@/components/Pages/Pbn/Lists/Tech'),
      meta: {
        breadcrumb: 'Tech',
        menu: 'Lists'
      }
    },
    {
      path: '/lists/seo',
      name: 'SEO View',
      component: () => import('@/components/Pages/Pbn/Lists/Seo'),
      meta: {
        breadcrumb: 'Seo',
        menu: 'Lists'
      }
    },
    {
      path: '/ppc/accounts',
      name: 'Accounts',
      component: () => import('@/components/Pages/PPC/Accounts'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Accounts'
      }
    },
    {
      path: '/ppc/orders',
      name: 'Orders',
      component: () => import('@/components/Pages/PPC/Orders'),
      meta: {
        breadcrumb: 'Orders',
        menu: 'PPC'
      }
    },
    {
      path: '/ppc/order/:id',
      name: 'Order',
      component: () => import('@/components/Pages/PPC/Orders/Order'),
      meta: {
        breadcrumb: 'Order',
        menu: 'PPC'
      }
    },
    {
      path: '/ppc/groups',
      name: 'Groups',
      component: () => import('@/components/Pages/PPC/Groups'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Groups'
      }
    },
    {
      path: '/ppc/clients',
      name: 'Clients',
      component: () => import('@/components/Pages/PPC/Clients'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Clients'
      }
    },
    {
      path: '/ppc/client/:id',
      name: 'Client',
      component: () => import('@/components/Pages/PPC/Clients/Client'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Clients'
      }
    },
    {
      path: '/ppc/account/:id',
      name: 'Account',
      component: () => import('@/components/Pages/PPC/Account'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Account'
      }
    },
    {
      path: '/ppc/cards',
      name: 'Accounts',
      component: () => import('@/components/Pages/PPC/Cards'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Accounts'
      }
    },
    {
      path: '/ppc/card/:id',
      name: 'Card',
      component: () => import('@/components/Pages/PPC/Card'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Card'
      }
    },
    {
      path: '/ppc/rdp',
      name: 'RDPs',
      component: () => import('@/components/Pages/PPC/Rdp'),
      meta: {
        breadcrumb: 'RDPs',
        menu: 'Accounts'
      }
    },
    {
      path: '/ppc/transactions',
      name: 'Accounts',
      component: () => import('@/components/Pages/PPC/Transactions'),
      meta: {
        breadcrumb: 'PPC',
        menu: 'Accounts'
      }
    },
    {
      path: '/pbn/templates',
      name: 'Templates',
      component: ToolboxPbnTemplates,
      meta: {
        breadcrumb: 'PBN Templates',
        menu: 'PBN Templates'
      }
    },
    {
      path: '/pbn/template/:id',
      name: 'Template',
      component: ToolboxPbnTemplate,
      meta: {
        breadcrumb: 'PBN Template',
        menu: 'Pbn Template'
      }
    },
    {
      path: '/pbn/link-orders',
      name: 'Link Orders',
      component: ToolboxPbnLinkOrders,
      meta: {
        breadcrumb: 'Link Orders',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/link-order/:id',
      name: 'Link Order',
      component: ToolboxPbnLinkOrder,
      meta: {
        breadcrumb: 'Link Order',
        menu: 'Pbns'
      }
    },
    {
      path: '/maintenance/orders',
      name: 'Maintenance Orders',
      component: ToolboxMaintenanceOrders,
      meta: {
        breadcrumb: 'Maintenance Orders',
        menu: 'Orders'
      }
    },
    {
      path: '/maintenance/order/:id',
      name: 'Maintenance Order',
      component: ToolboxMaintenanceOrderSingle,
      meta: {
        breadcrumb: 'Maintenance Order',
        menu: 'Order'
      }
    },
    {
      path: '/maintenance/task/:id',
      name: 'Task',
      component: ToolboxMaintenanceTask,
      meta: {
        breadcrumb: 'Task',
        menu: 'Task'
      }
    },
    {
      path: '/maintenance/tasks',
      name: 'Tasks',
      component: ToolboxMaintenanceTasks,
      meta: {
        breadcrumb: 'Tasks',
        menu: 'Tasks'
      }
    },
    {
      path: '/pbn',
      name: 'Pbns',
      component: ToolboxPbns,
      meta: {
        breadcrumb: 'Pbns',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/reports',
      name: 'Overview',
      component: ToolboxPbnOverview,
      meta: {
        breadcrumb: 'Reports',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/orders',
      name: 'Orders',
      component: ToolboxPbnOrders,
      meta: {
        breadcrumb: 'Pbn Orders',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/order/:orderId',
      name: 'Order',
      component: ToolboxPbnOrder,
      meta: {
        breadcrumb: 'Pbn Order',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/builds',
      name: 'Builds',
      component: ToolboxPbnBuilds,
      meta: {
        breadcrumb: 'Pbn Builds',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/builds/report',
      name: 'Build Report',
      component: ToolboxPbnBuildsReport,
      meta: {
        breadcrumb: 'Pbn Build Report',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/builds/queue',
      name: 'Build Queue',
      component: ToolboxPbnBuildQueue,
      meta: {
        breadcrumb: 'Pbn Build Queue',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/domains',
      name: 'Pbn',
      component: ToolboxDomains,
      meta: {
        breadcrumb: 'Domains',
        menu: 'Pbns'
      }
    },
    {
      path: '/pbn/:domain',
      name: 'Pbn',
      component: ToolboxPbn,
      meta: {
        breadcrumb: 'Pbn',
        menu: 'Pbns'
      }
    },
    {
      path: '/site/:id',
      name: 'Site',
      component: Site,
      meta: {
        breadcrumb: 'Site',
        menu: 'Sites'
      }
    },
    {
      path: '/site/:id/post/:postId',
      name: 'Post',
      component: Site,
      meta: {
        breadcrumb: 'Post',
        menu: 'Sites'
      }
    },
    {
      path: '/posts/search',
      component: PostSearch,
      meta: {
        breadcrumb: 'Search posts'
      }
    },
    {
      path: '/apps/link-pyramid',
      name: 'Link Pyramids',
      component: LinkPyramids,
      meta: {
        breadcrumb: 'Link Pyramid',
        menu: 'Link Pyramid'
      }
    },
    {
      path: '/apps/link-pyramid/:pyramidId',
      name: 'Link Pyramid',
      component: LinkPyramid,
      meta: {
        breadcrumb: 'Pyramid',
        menu: 'Link Pyramid'
      }
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients,
      meta: {
        breadcrumb: 'Clients',
        menu: 'Clients'
      }
    },
    {
      path: '/client/:clientId/:orderId?',
      name: 'Client',
      component: Client,
      meta: {
        breadcrumb: 'Client',
        menu: 'Clients'
      }
    },
    {
      path: '/stats',
      name: 'Stats',
      component: Stats,
      meta: {
        breadcrumb: 'Stats',
        menu: 'Stats'
      }
    },
    {
      path: '/xs',
      name: 'Shells',
      component: XsUploads,
      meta: {
        breadcrumb: 'Shells',
        menu: 'Shells'
      },
      children: [
        {
          path: '/xs/uploads',
          name: 'Uploads',
          component: XsUploads,
          meta: {
            breadcrumb: 'Uploads'
          }
        }
      ]
    },
    {
      path: '/xs/upload/:id',
      name: 'Upload',
      component: XsUpload,
      meta: {
        breadcrumb: 'Shells',
        menu: 'Upload'
      }
    },
    {
      path: '/admin/users',
      name: 'Admin Users',
      component: AdminUsers,
      meta: {
        breadcrumb: 'Admin Users',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/user/:id',
      name: 'Admin User',
      component: AdminUser,
      meta: {
        breadcrumb: 'Admin User',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/clients',
      name: 'Admin Clients',
      component: () => import('@/components/Pages/Admin/Clients/Clients'),
      meta: {
        breadcrumb: 'Admin Clients',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/clients/:id',
      name: 'Admin Clients',
      component: () => import('@/components/Pages/Admin/Clients/Client'),
      meta: {
        breadcrumb: 'Admin Clients',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/roles',
      name: 'Admin User Roles',
      component: AdminUserRoles,
      meta: {
        breadcrumb: 'Admin User Roles',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/billing',
      name: 'Admin Billing',
      component: AdminBilling,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Admin'
      }
    },
    {
      path: '/task-manager/projects',
      name: 'Projects',
      component: Projects,
      meta: {
        breadcrumb: 'Projects',
        menu: 'Task Manager'
      }
    },
    {
      path: '/task-manager/projects/:id',
      name: 'Project',
      component: Project,
      meta: {
        breadcrumb: 'Project',
        menu: 'Task Manager'
      }
    },
    {
      path: '/task-manager/projects/:slug',
      name: 'Project',
      component: Project,
      meta: {
        breadcrumb: 'Project',
        menu: 'Task Manager'
      }
    },
    {
      path: '/task-manager/tasks',
      name: 'Tasks',
      component: TaskList,
      meta: {
        breadcrumb: 'Tasks'
      }
    },
    {
      path: '/task-manager/tasks/:id',
      name: 'Task',
      component: TaskDetail,
      meta: {
        breadcrumb: 'Task Detail'
      }
    },
    {
      path: '/admin/data',
      name: 'Admin Data',
      component: Data,
      meta: {
        breadcrumb: 'Data',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/data-lists',
      name: 'Admin Data Lists',
      component: DataLists,
      meta: {
        breadcrumb: 'Data Lists',
        menu: 'Admin'
      }
    },
    {
      path: '/admin/role/:id',
      name: 'Admin User Role',
      component: AdminUserRole,
      meta: {
        breadcrumb: 'Admin User Role',
        menu: 'Admin'
      }
    },
    {
      path: '/account/registrars',
      name: 'Accounts Registrars',
      component: AccountRegistrars,
      meta: {
        breadcrumb: 'Account Registrars',
        menu: 'Accounts'
      }
    },
    {
      path: '/account/registrar/:id',
      name: 'Accounts Registrar',
      component: AccountRegistrar,
      meta: {
        breadcrumb: 'Accounts Registrar',
        menu: 'Accounts'
      }
    },
    {
      path: '/account/hosts',
      name: 'Hosts',
      component: AccountHosts,
      meta: {
        breadcrumb: 'Hosts',
        menu: 'Hosts'
      }
    },
    {
      path: '/account/host/:id',
      name: 'Host',
      component: AccountHost,
      meta: {
        breadcrumb: 'Host',
        menu: 'Host'
      }
    },
    {
      path: '/account/users',
      name: 'Users',
      component: ClientAccountUsers,
      meta: {
        breadcrumb: 'Account',
        menu: 'Users'
      }
    },
    {
      path: '/account/user/:id',
      name: 'User',
      component: ClientAccountUser,
      meta: {
        breadcrumb: 'User',
        menu: 'Account'
      }
    },
    {
      path: '/account/billing',
      name: 'Billing',
      component: ClientAccountBilling,
      meta: {
        breadcrumb: 'Account',
        menu: 'Billing'
      }
    },
    {
      path: '/admin/billing/items',
      name: 'Products',
      component: BillingItems,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Products'
      }
    },
    {
      path: '/admin/billing/contacts',
      name: 'Contacts',
      component: BillingContacts,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Contacts'
      }
    },
    {
      path: '/admin/billing/accounts',
      name: 'Accounts',
      component: BillingAccounts,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Accounts'
      }
    },
    {
      path: '/admin/billing/tracking',
      name: 'Tracking',
      component: BillingTracking,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Tracking'
      }
    },
    {
      path: '/admin/billing/invoices',
      name: 'Invoices',
      component: Invoices,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Invoices'
      }
    },
    {
      path: '/admin/billing/invoices/new',
      name: 'New Invoice',
      component: NewInvoice,
      meta: {
        breadcrumb: 'Billing',
        menu: 'New Invoice'
      }
    },
    {
      path: '/admin/billing/invoice/:id',
      name: 'Invoice',
      component: SingleInvoice,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Invoice'
      }
    },
    {
      path: '/admin/billing/invoice/:id/edit',
      name: 'Edit Invoice',
      component: NewInvoice,
      meta: {
        breadcrumb: 'Billing',
        menu: 'Invoice'
      }
    },
    {
      path: '/advertisers/affiliatecompanies',
      name: 'affiliatecompanies',
      component: AffiliateCompanies,
      meta: {
        breadcrumb: 'Affiliate Companies Overview'
      }
    },
    {
      path: '/advertisers/affiliatecompany/:id',
      name: 'affiliatecompanies',
      component: AffiliateCompany,
      meta: {
        breadcrumb: 'Affiliate Company Overview'
      }
    },
    {
      path: '/advertisers/brands',
      name: 'Advertisers',
      component: Advertisers,
      meta: {
        breadcrumb: 'Brands overview'
      }
    },
    {
      path: '/advertisers/brand/:id',
      name: 'Advertiser',
      component: Advertiser,
      meta: {
        breadcrumb: 'Brand overview',
        menu: 'Advertiser'
      }
    },
    {
      path: '/advertisers/toplists',
      name: 'Toplists',
      component: Toplists,
      meta: {
        breadcrumb: 'Toplists overview'
      }
    },
    {
      path: '/advertisers/toplist/:id',
      name: 'Toplist',
      component: Toplist,
      meta: {
        breadcrumb: 'Toplist overview'
      }
    },
    {
      path: '/search-console',
      name: 'Search Console',
      component: () => import('@/components/Pages/SearchConsole/SearchConsole'),
      meta: {
        breadcrumb: 'Search Console',
        menu: 'Admin'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/instalinko/webmasters',
      name: 'Webmasters',
      component: InstalinkoWebmasters,
      meta: {
        breadcrumb: 'Webmasters',
        auth: true
      }
    },
    {
      path: '/instalinko/webmaster/:id',
      name: 'Webmaster',
      component: InstalinkoWebmaster,
      meta: {
        breadcrumb: 'Webmaster',
        menu: 'Webmasters'
      }
    },
    {
      path: '/instalinko/orders',
      name: 'Instalinko Orders',
      component: InstalinkoOrders,
      meta: {
        breadcrumb: 'Orders',
        menu: 'Orders'
      }
    },
    {
      path: '/instalinko/order/:id',
      name: 'Order By Id',
      component: InstalinkoOrder,
      meta: {
        breadcrumb: 'Order',
        menu: 'Order'
      }
    },
    {
      path: '/instalinko/inventory',
      name: 'Inventory',
      component: InstalinkoInventories,
      meta: {
        breadcrumb: 'Inventory',
        menu: 'Inventory'
      }
    },
    {
      path: '/instalinko/inventory/create',
      name: 'AddInventory',
      component: InstalinkoInventoryAdd,
      meta: {
        breadcrumb: 'Add Inventory',
        menu: 'Add Inventory'
      }
    },
    {
      path: '/instalinko/inventory/:id',
      name: 'Inventory By Id',
      component: InstalinkoInventory,
      meta: {
        breadcrumb: 'Inventory',
        menu: 'Inventory'
      }
    },
    {
      path: '/instalinko/writers',
      name: 'Writers',
      component: InstalinkoWriters,
      meta: {
        breadcrumb: 'Writers',
        menu: 'Writers'
      }
    },
    {
      path: '/instalinko/clients',
      name: 'InstalinkoClients',
      component: InstalinkoClients,
      meta: {
        breadcrumb: 'Clients',
        menu: 'Clients'
      }
    },
    {
      path: '/instalinko/client/:id',
      name: 'InstalinkoClient',
      component: InstalinkoClient,
      meta: {
        breadcrumb: 'Client',
        menu: 'Client'
      }
    },
    {
      path: '/instalinko/reports',
      name: 'InstalinkoReports',
      component: InstalinkoReports,
      meta: {
        breadcrumb: 'Instalinko Reports',
        menu: 'Instalinko Reports'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js